import rechargeDelivery from './recharge_delivery.vue'

export default {
    path: 'rechargeDelivery',
    component: rechargeDelivery
}
